
import { Box, Button, Flex, Text, useDisclosure, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, Spinner, } from "@chakra-ui/react";
import MyDiv from "./documentUploadCard.style";
import { useEffect, useState } from "react";
import { CustomToast } from "../../../../../components";
import { baseUrl, useFetch } from "../../../../../hooks/useFetch";
import { ICandidateList } from "../../OnboardCandidateList/modal";

interface DocumentProps {
  document: ICandidateList | null;
}

interface ICandidateDocument {
  id: number;
  fileName: string;
  fileContent?: string;
  fileType?: string;
  document_Category?: string,
  document_Name?: string,
}

const DocumentUploadCard = ({ document }: DocumentProps) => {
  const { addToast } = CustomToast();
  const { fetchApi } = useFetch(addToast);

  const [documents, setDocuments] = useState<ICandidateDocument[]>([{ id: 0, fileName: "", fileContent: "", }]);
  const [loading, setLoading] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState<ICandidateDocument | null>(null);

  const { isOpen, onOpen, onClose } = useDisclosure();

  // Load candidate documents from API
  const loadCandidateDocuments = async () => {
    if (!document?.candidate_Id) return;
    setLoading(true);
    try {
      const response = await fetchApi("OfferAndOnBoarding/CandidateDocuments", "GET", "", `candidate_Id=${document.candidate_Id}`, "");
      if (response && Array.isArray(response)) {
        setDocuments(response);
        if (response.length > 0) {
          setSelectedDoc(response[0]);
        }
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadCandidateDocuments();
  }, [document]);

  const handleViewDocument = async (doc: ICandidateDocument) => {
    setSelectedDoc(doc);
    setLoading(true);
    try {
      const response = await fetch(`${baseUrl}OfferAndOnBoarding/DownloadCandidateDocument?documentId=${doc.id}`
      );
      if (!response.ok) throw new Error("Failed to fetch document");
      const blob = await response.blob();
      const fileType = blob.type;
      const fileURL = URL.createObjectURL(blob);
      setSelectedDoc({ ...doc, fileContent: fileURL, fileType });
      onOpen();
    } catch (err) {
      console.error(err);
      addToast({ message: "Failed to load document", status: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <MyDiv>
      <Box className="cards">
        <Box px={4} py={2}>
          <Text className="font-poppins text_xxl text_medium" mb={4}>
            View Document
          </Text>
          <Text className="font-poppins text_lg text_medium mb={4}">
            Uploaded Documents
          </Text>

          {loading ? (
            <Flex justify="center" align="center" minH="100px">
              <Spinner />
            </Flex>
          ) : documents.length === 0 ? (
            <Text>No documents uploaded.</Text>
          ) : (
            <Box>
              {documents.map((doc) => (
                <Flex key={doc.id} justify="space-between" align="center" p={2} borderBottom="1px solid #eee">
                  <Box>
                    <Text className="font-poppins text_md text_medium">
                      {doc.document_Name}
                    </Text>
                    <Text className="font-poppins text_sm text_regular" color="gray.500">
                      {doc.document_Category}
                    </Text>
                  </Box>
                  <Button size="sm" onClick={() => handleViewDocument(doc)}>
                    View
                  </Button>
                </Flex>
              ))}

            </Box>
          )}
        </Box>
      </Box>

      <Modal isOpen={isOpen} onClose={onClose} size="6xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {selectedDoc?.document_Name || "Document Preview"}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody p={0} overflowY="auto">
            {selectedDoc?.fileContent ? (
              selectedDoc.fileType?.includes("pdf") ? (
                <iframe src={selectedDoc.fileContent} width="100%" height="800px" style={{ border: "none", display: "block" }} title={selectedDoc.fileName} />
              ) : selectedDoc.fileType?.startsWith("image") ? (
                <img src={selectedDoc.fileContent} alt={selectedDoc.fileName} style={{ width: "100%", maxHeight: "500px", objectFit: "contain" }} />
              ) : (
                <Text p={4}>Cannot preview this file type</Text>
              )
            ) : (
              <Text p={4}>No document selected!</Text>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </MyDiv>
  );
};

export default DocumentUploadCard;
